<template>
  <div style="margin-top:30px">
    <el-form ref="form" :rules="rules" :model="form" label-width="80px">
      <el-form-item label="字段名称" prop="fieldName" style="margin-right:15px">
        <el-input v-model="form.fieldName" placeholder="请输入字段名称" />
      </el-form-item>
      <el-form-item label="字段" prop="fieldValue" style="margin-right:15px">
        <el-input v-model="form.fieldValue" placeholder="请输入字段" />
      </el-form-item>
      <el-form-item
        label="是否必填"
        prop="isRequired"
        style="margin-right:15px"
      >
        <el-select v-model="form.isRequired" placeholder="请选择">
          <el-option label="否" value="0" />
          <el-option label="是" value="1" />
        </el-select>
      </el-form-item>
      <el-form-item label="功能模块" prop="fieldFrom" style="margin-right:15px">
        <el-select v-model="form.fieldFrom" placeholder="请选择">
          <el-option label="实际承运人" value="driver" />
          <el-option label="车队" value="driverTeam" />
          <el-option label="托运人" value="shipment" />
          <el-option label="企业托运人" value="shipmentCompany" />
        </el-select>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="funcCancel">取 消</el-button>
      <el-button type="primary" @click="funcSubmit">确 定</el-button>
    </div>
  </div>
</template>
<script>
import request from "@/utils/request";
export default {
  name: "FieldRequiredSettingAdd",
  data() {
    return {
      form: {
        fieldName: "",
        fieldValue: "",
        isRequired: "",
        fieldFrom: ""
      },
      rules: {
        fieldName: [
          { required: true, message: "请输入字段名称", trigger: "blur" },
          { min: 1, max: 50, message: "长度在 1 到 50 个字符", trigger: "blur" }
        ],
        fieldValue: [
          { required: true, message: "请输入字段", trigger: "blur" },
          { min: 1, max: 50, message: "长度在 1 到 50 个字符", trigger: "blur" }
        ],
        isRequired: [
          { required: true, message: "请选择是否必填", trigger: "blur" },
          { min: 1, max: 50, message: "长度在 1 到 50 个字符", trigger: "blur" }
        ],
        fieldFrom: [
          { required: true, message: "请选择字段所属功能", trigger: "blur" },
          { min: 1, max: 50, message: "长度在 1 到 50 个字符", trigger: "blur" }
        ]
      }
    };
  },
  created() {},
  methods: {
    //提交
    funcSubmit() {
      this.$refs["form"].validate(valid => {
        if (valid) {
          const data = this.form;
          const rLoading = this.openLoading();
          request({
            url: "/ntocc-basic-api/fieldRequiredSetting",
            method: "post",
            params: data
          })
            .then(response => {
              this.$message({ message: response.msg, type: "success" });
              this.$emit("fatherAddMethod");
            })
            .then(() => this.$refs["form"].resetFields(), rLoading.close());
        } else {
          return false;
        }
      });
    },
    //取消
    funcCancel() {
      this.$emit("fatherCancelMethod", "add");
    }
  }
};
</script>
<style lang="scss" scoped>
.dialog-footer {
  margin: 15px 0 15px 0;
  width: 175px;
  float: right;
}
</style>
